













import BigItemCard from '@/components/item-cards/BigItemCard.vue';
import SmallItemCard from '@/components/item-cards/SmallItemCard.vue';
import OwnerItemCard from '@/components/item-cards/OwnerItemCard.vue';

import { Component, Prop, Vue } from 'vue-property-decorator';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';

import { ProductItem } from '@/models/items/product-item-model';
import { PlaceItem } from '@/models/items/place-item-model';
import { GenericItem } from '@/models/items/generic-item-model';
import {
  AbstractItemModel,
  ItemType
} from '../models/items/abstract-item-model';

@Component({
  components: { BigItemCard, SmallItemCard, OwnerItemCard }
})
export default class ItemCardDebugPage extends Vue {
  public items: GenericItem[] = [];
  list = ListModel.empty();

  public created() {
    this.items.push(new ProductItem().makeDummy());
    this.items.push(new PlaceItem().makeDummy());
    this.items.push(new GenericItem().makeDummy());
  }
}
